
import React from 'react';
import { AlertDialog } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import DeleteAccountDialog from './DeleteAccountDialog';
import { useAccountDeletion } from './useAccountDeletion';

const AccountDeletionSection: React.FC = () => {
  const {
    open,
    setOpen,
    isDeleting,
    feedback,
    setFeedback,
    reason,
    setReason,
    handleDeleteAccount
  } = useAccountDeletion();

  return (
    <div className="border border-destructive/20 rounded-lg p-4 sm:p-6 bg-destructive/5 w-full">
      <div className="flex flex-col sm:flex-row sm:items-start gap-4">
        <div className="p-2 rounded-full bg-destructive/10 text-destructive self-start">
          <Trash2 className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-medium">Delete Account</h3>
          <p className="text-muted-foreground mt-1">
            Permanently delete your account and all associated data. This action cannot be undone.
          </p>
          
          <Button 
            variant="destructive" 
            className="mt-4 w-full sm:w-auto"
            onClick={() => setOpen(true)}
          >
            Delete Account
          </Button>
        </div>
      </div>

      <AlertDialog open={open} onOpenChange={setOpen}>
        <DeleteAccountDialog
          isDeleting={isDeleting}
          feedback={feedback}
          setFeedback={setFeedback}
          reason={reason}
          setReason={setReason}
          handleDeleteAccount={handleDeleteAccount}
        />
      </AlertDialog>
    </div>
  );
};

export default AccountDeletionSection;
